import styled from "styled-components";
import { H2, P, MainWrapper } from "@/lib/styles";
import { pageMaxWidth } from "@/lib/styles/helpers";

export const Container = styled.div`
  position: relative;
  padding-top: 7.25rem;
  padding-bottom: 1.5rem;
`;

export const Heading = styled(MainWrapper)`
  position: relative;
  display: none;
`;

export const Title = styled(H2)`
  text-align: left;
  ${({ theme }) => theme.mediaQueries.laptop} {
    width: 50%;
  }
`;

export const Subtitle = styled(P)`
  text-align: left;
  margin-top: 1rem;
  padding: 0.5rem 0;
  background-color: ${({ theme }) => theme.colors.white};
  ${({ theme }) => theme.mediaQueries.laptop} {
    width: calc(50% - 2px);
  }
`;

export const RelatedWrapper = styled.div`
  ${pageMaxWidth};
  position: relative;
`;
